itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;
    const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    }

    var initScrollActions = function (el, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            if (cb && typeof cb !== "function") {
                
            } else {
                if (el.classList.contains("js-intro-viruses")) {
                    ScrollTrigger.clearScrollMemory();
                    let mm = gsap.matchMedia();


                    mm.add("(min-width: 1024px)", () => {
                        // gsap.set(".microbe--left", {
                        //     x: 100
                        // });

                        // gsap.set(".microbe--right", {
                        //     x: -100
                        // });
                        var tl = gsap.timeline();

                        tl.addLabel("origin");
                        
                        tl.to(".microbe--left", {
                            duration: 2,
                            x: 45,
                            ease: "power1.inOut",
                            stagger: {
                                from: "center",
                                amount: 0.3
                            }
                        }, "origin")
                        .addLabel("translate-end")
                        .to(".microbe--left", {
                            scale: 0,
                            duration: 0.5,
                            ease: "power4.in",
                            stagger: {
                                from: "edges",
                                each: 0.1,
                                ease: "power1.in"
                            }
                        }, "translate-end+=50%")
                        .to(".microbe--right", {
                            scale: 0,
                            duration: 0.5,
                            ease: "power4.in",
                            stagger: {
                                from: "edges",
                                each: 0.1,
                                ease: "power1.in"
                            }
                        }, "translate-end+=50%");

                        tl.to(".microbe--right", {
                            duration: 2,
                            x: -45,
                            ease: "power1.inOut",
                            stagger: {
                                from: "center",
                                amount: 0.3
                            }
                        }, "origin")
                    });
                // } else if (el.classList.contains("js-woman-viruses")) {
                    
                } else if (el.classList.contains("js-scroll-section")) {
                    ScrollTrigger.clearScrollMemory();
                    var sections = gsap.utils.toArray('.js-scroll-section');
                    var items;
                    var thisPinWrap;
                    var thisAnimWrap;
                    let mm = gsap.matchMedia();
                    let cbFlag = false;

                    sections.forEach(function (sec, i) {	
                        const scrollLine = sec.querySelector(".page__dashed-path");
                        let params;
                        let updateParams;
                        let pathLength;

                        if (scrollLine) {
                            params = itsoftApp.modules.dashAnimation.initCustomAnimation(scrollLine);
                            updateParams = params.updateParams;
                            pathLength = params.pathLength;
                        }

                        items = sec.querySelectorAll('.js-scroll-item');
                        thisPinWrap = sec.querySelector('.js-pin-wrap');
                        thisAnimWrap = thisPinWrap.querySelector('.js-animation-wrap');

                        var getToValue = () => -(thisAnimWrap.clientWidth * (items.length - 1));

                        mm.add("(max-width: 767px)", () => {
                            gsap.fromTo(thisAnimWrap, { 
                                x: 0,
                                }, { 
                                x: -(items[0].clientWidth * ( items.length - 1) + 20 * 2), 
                                ease: "none",
                                scrollTrigger: {
                                    trigger: sec,
                                    start: sec.hasAttribute('data-start') ? sec.getAttribute('data-start') : "center 10%",
                                    end: () => "+=" + (items[0].clientWidth * ( items.length - 1)),
                                    pin: thisPinWrap,
                                    invalidateOnRefresh: true,
                                    scrub: true,
                                    onUpdate: function (self) {
                                        if (scrollLine) {
                                            updateParams(pathLength - self.progress * pathLength);
                                        }
                                    },
                                    onRefresh: (self) => {
                                        if (cb && !cbFlag) {
                                            cbFlag = true;
                                            cb();
                                        }
                                    }
                                }
                            });
                        });

                        mm.add("(min-width: 768px) and (max-width: 1023px)", () => {
                            gsap.fromTo(thisAnimWrap, { 
                                x: 0,
                                }, { 
                                x: -(items[0].clientWidth * ( items.length - 2) + 20 * 3), 
                                ease: "none",
                                scrollTrigger: {
                                    trigger: sec,
                                    start: sec.hasAttribute('data-start') ? sec.getAttribute('data-start') : "center 20%",
                                    end: () => "+=" + (items[0].clientWidth * ( items.length - 1)),
                                    pin: thisPinWrap,
                                    invalidateOnRefresh: true,
                                    scrub: true,
                                    onUpdate: function (self) {
                                        if (scrollLine) {
                                            updateParams(pathLength - self.progress * pathLength);
                                        }
                                    },
                                    onRefresh: (self) => {
                                        if (cb && !cbFlag) {
                                            cbFlag = true;
                                            cb();
                                        }
                                    }
                                }
                            });
                        });

                        mm.add("(min-width: 1024px)", () => {
                            gsap.fromTo(thisAnimWrap, { 
                                x: 0,
                                }, { 
                                x: -(items[0].clientWidth * ( items.length - 2) + 20 * 3), 
                                ease: "none",
                                scrollTrigger: {
                                    trigger: sec,
                                    start: sec.hasAttribute('data-start') ? sec.getAttribute('data-start') : "center 55%",
                                    end: () => "+=" + (items[0].clientWidth * ( items.length - 1)),
                                    pin: thisPinWrap,
                                    invalidateOnRefresh: true,
                                    scrub: true,
                                    onUpdate: function (self) {
                                        if (scrollLine) {
                                            updateParams(pathLength - self.progress * pathLength);
                                        }
                                    },
                                    onRefresh: (self) => {
                                        if (cb && !cbFlag) {
                                            cbFlag = true;
                                            cb();
                                        }
                                    }
                                }
                            });
                        });

                        var tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: sec,
                                start: 'top 30%'
                            }
                        });

                        tl.addLabel("originNew");
                        
                        tl.to(".problem-microbe--left", {
                            duration: 2,
                            x: 0,
                            ease: "power1.inOut",
                            stagger: {
                                from: "center",
                                amount: 0.3
                            }
                        }, "originNew")
                        .to(".problem-microbe", {
                            opacity: 1,
                            duration: 1
                        }, "originNew+=50%");

                        tl.to(".problem-microbe--right", {
                            duration: 2,
                            x: 0,
                            ease: "power1.inOut",
                            stagger: {
                                from: "center",
                                amount: 0.3
                            }
                        }, "originNew")
                    });
                }
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    }

    module.callback = initScrollActions;
});


